import {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import getMuiTheme from '@material-ui/styles/getThemeProps';
import {AppBackground, FullSize} from '../../styles/BaseStyles'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
//import MuiThemeProvider from '@material-ui/core';
import AppView from './AppView';
import {
    onInitialize,
    onSetAuthenticationState,
    onSetLanguage,
    onSetViewState,
    onTerminate
} from '../../actions/AppActions';
import {isAuthenticatedAction, renewSessionAction} from "../../redux/modules/login";

// Needed for Material-UI TouchTap integration
//injectTapEventPlugin();

const muiTheme = getMuiTheme({
});

const MainPanelStyle = Object.assign({}, FullSize, AppBackground);



class MainView extends Component {
    constructor(props) {
        super(props);
        this.checkAuthentication = this.checkAuthentication.bind(this);
        this.onClick = this.onClick.bind(this);

        // Triggered on app load
        this.checkAuthentication();
    }


    onClick(argData){

        console.log("Click got called") ;
        // this.setState({bathingRecordData:argData});

    }

   async checkAuthentication() {
        const authenticated = true;
        let {onSetAuthenticationState, appState, onInitialize, onTerminate, isAuthenticatedAction} = this.props;
        if (isAuthenticatedAction() !== authenticated) {
            onSetAuthenticationState(authenticated, noop, noop);
            if (authenticated) {
                //onInitialize();
            } else {
                //onTerminate();
            }
        }
    }

   /* componentDidUpdate() {
        // Triggered when user initiates a logout
       this.checkAuthentication();
    }
 */
        componentDidMount() {
            //const { renewSession} = this.props;
            let { updateLoginData, loadLoginData ,renewSessionAction} = this.props;
            //this.props.auth.goHome= this.goHomeClickHere;
            /*if (localStorage.getItem('isLoggedIn') === 'true') {
                renewsession();
            }*/

            if (this.props.isAuthenticatedBool ) {
                renewSessionAction();
            }
            //isAuthenticated
           // var tempLogin = this.props.loginData;

           // console.log("The login data is " + tempLogin);
        }



    /*

    <div style={MainPanelStyle}>
                    {[0].map(() => {return appState.isAuthenticated ?
                        React.createElement(AppView, this.props)
                        :
                        <WelcomeView login={appState.onLogin}/>
                    })}
                </div>

     */
    render() {
        let {appState} = this.props;

        return (
            <MuiThemeProvider muiTheme={muiTheme}>
            {/*<WelcomeView login={this.onClick}/>  */}
            <AppView  auth={this.props.auth} />
            </MuiThemeProvider>
        );
    }
};

const mapStateToProps = state => {
    let props = {
        appState: state.appState,
        viewState: state.viewState,
        loginData: state.login.loginData,
        isAuthenticatedBool:state.login.isAuthenticatedBool,

    };

    return (props);
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        onSetAuthenticationState: onSetAuthenticationState,
        onInitialize: onInitialize,
        onTerminate: onTerminate,
        onSetViewState: onSetViewState,
        onSetLanguage: onSetLanguage,
        //updateLoginDataAction:updateLoginDataAction,
        //saveLoginData:saveLoginData,
        //loadLoginData:loadLoginData,
        isAuthenticatedAction:isAuthenticatedAction,
        renewSessionAction:renewSessionAction,

    }, dispatch);
};

function noop() {}


export default connect(mapStateToProps, mapDispatchToProps)(MainView);
